import React, { useState, useRef } from "react";
import StartScreen from "./screens/StartScreen";
import GameEngineScreen from "./screens/GameEngineScreen";
import ImpressumScreen from "./screens/ImpressumScreen";
import DatenschutzScreen from "./screens/DatenschutzScreen";
import useMobileViewport from "./hooks/useMobileViewport";
import useAppSize from "./hooks/useAppSize";

function App() {
  const [screen, setScreen] = useState("start"); // 'start', 'game', 'impressum', 'datenschutz'
  const [gameMode, setGameMode] = useState(null); // e.g., 'training', 'combo'
  const appRef = useRef(null);
  const appSize = useAppSize(appRef);

  // Handle iOS Safari viewport height issues
  useMobileViewport();

  const handleSelectMode = (mode) => {
    setGameMode(mode);
    setScreen("game");
  };

  const handleBack = () => {
    setScreen("start");
  };

  const handleNavigate = (screenName) => {
    setScreen(screenName);
  };

  const renderScreen = () => {
    switch (screen) {
      case "start":
        return (
          <StartScreen
            onSelectMode={handleSelectMode}
            onNavigate={handleNavigate}
          />
        );
      case "game":
        return (
          <GameEngineScreen
            mode={gameMode}
            onBack={handleBack}
            appSize={appSize}
          />
        );
      case "impressum":
        return <ImpressumScreen onBack={handleBack} />;
      case "datenschutz":
        return <DatenschutzScreen onBack={handleBack} />;
      default:
        return (
          <StartScreen
            onSelectMode={handleSelectMode}
            onNavigate={handleNavigate}
          />
        );
    }
  };

  return (
    <div className="App" ref={appRef}>
      {renderScreen()}
    </div>
  );
}

export default App;
